
// SVG Icon: bar-chart
export default { id: "terriajs-bar-chart" };
export const id = "terriajs-bar-chart";
export const name = "bar-chart";
